module.exports = __webpack_public_path__ + "static/img/scare3.7b4d0369.png";